import React, { useContext, useEffect, useState, useRef } from "react";
import { UserContext } from "../../context/UserDetails";
// import banner from '../../img/banner/ban1.jpg';
import "../../Themes/themes.css";
import styles from "./IndexPage.module.css";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import LogoutListener from "../../context/LogoutListener";
import { Link, useNavigate } from "react-router-dom";
import ModelCompontent from "./ModelCompontent";
import Footer from "../../features/Core/Footer/Footer";
import PaymentDueModel from "../PaymentDueModel";
import { AxiosInstance } from "../../axios";
import Swal from "sweetalert2";
import ModelComForP from "../ModelComForP";
import WarningPopUp from "../../shared/Component/BackOffice/StudentTestWorkflow/WarningPopUp";
import RaiseQuery from "../../shared/Component/BackOffice/StudentTestWorkflow/RaiseQuery";
import ViewQuery from "../../shared/Component/BackOffice/StudentTestWorkflow/ViewQuery";
import ViewExplaination from "../../shared/Component/BackOffice/StudentTestWorkflow/ViewExplaination";
import { ImageUrlPrefix } from "../../labels";
import CourseCategory from "../dashboard/CourseCategory";
import "./CourseCategory.module.css";
import "./Top10squad.module.css";
import Top10squad from "../dashboard/Top10squad";
import "bootstrap/dist/css/bootstrap.min.css";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft"; // Import ChevronLeftIcon
import ChevronRightIcon from "@mui/icons-material/ChevronRight"; // Import ChevronRightIcon
import listImage from "./ic_send_24px.png";
import BestSellers from "./BestSellers";
import styless from "../../pages/dashboard/CourseCategory.module.css";
import style from "../../shared/Component/BackOffice/BookModule/HomePage/StudyMaterial.module.css";
import toast from "react-hot-toast";
import { CartContext } from "../../context/CartItems";
import { WishListContext } from "../../context/WishListItems";
import moment from "moment";
import red_undeline from "../../img/dashboard/Red Underline (1).png";
import separator_pattern_right from "../../img/dashboard/Bottom Separator Pattern - Right (1).png";
import separator_pattern_left from "../../img/dashboard/Bottom Separator Pattern - Left (1).png";
function IndexPage() {
  const { user } = useContext(UserContext);
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [showModalData, setShowModalData] = useState({});
  const [images, setImages] = useState([]);
  const [updateListData, setUpdateListData] = useState([]);
  const [categoryId, setCategoryId] = useState([]); // Category list for filter checkboxes
  const [announcementList, setAnnouncementList] = useState("");
  const [isExpanded, setIsExpanded] = useState(true); // State to toggle the div
  const marqueeRef = useRef(null); // Ref for marquee control

  const toggleView = () => {
    setIsExpanded(!isExpanded); // Toggle the expanded state
  };

  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;
  let role_id = null;
  let user_type = null;
  let menuData = null;
  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user?.user_id) {
      userid = user?.user_id;
      role_id = user?.role_id;
      user_type = user?.user_type;
      menuData = user?.menu_list;
    }
  } else {
    console.log("User Id cannot available in session storage");
  }
  const [activeIndex, setActiveIndex] = useState(0);
  // announcement
  const [isOpen, setIsOpen] = useState(false); // State to manage collapse

  useEffect(() => {
    setShowModal(true); // Show the modal when the component loads
    if (userid) {
      AxiosInstance.post("api/user/reminder/byId", { user_id: userid })
        .then((res) => {
          if (res.data.status === true) {
            const dueDetailsData = res.data.data;
            const dueDetailsString = JSON.stringify(dueDetailsData);
            sessionStorage.setItem("DueDetails", dueDetailsString);
            localStorage.setItem("DueDetails", dueDetailsString);
            setShowModalData(dueDetailsData);
          }
        })
        .catch((error) => {
          return error;
        });
    }
    const folderPayloadImage = {
      is_admin: 0,
      page: "",
      page_size: "",
    };

    AxiosInstance.post("/api/gallery/banner/list", folderPayloadImage)
      .then((res) => {
        if (res.data.data.length > 0) {
          setImages(res.data.data);
        }
      })
      .catch((error) => {
        return error;
      });
  }, []);

  const toggleCollapse = () => {
    setIsOpen(!isOpen); // Toggle collapse state
  };

  useEffect(() => {
    const interval = setInterval(nextSlide, 2000); // Slide every minute
    return () => {
      clearInterval(interval);
    };
  }, [activeIndex]);

  const nextSlide = () => {
    setActiveIndex((prevIndex) => {
      if (prevIndex === images.length - 1) {
        return prevIndex;
      }
      return prevIndex + 1;
    });
    if (activeIndex === images.length - 1) {
      setTimeout(() => {
        setActiveIndex(0);
      }, 2000);
    }
  };
  // main exam model box close

  const handleCloseModal = () => {
    setShowModal(false);
  };

  // getAnnouncement api integration //
  useEffect(() => {
    AxiosInstance.get("api/all/getAnnouncement")
      .then((res) => {
        if (res.status === 200 && Array.isArray(res.data.data)) {
          const groupedData = res.data.data.reduce((acc, item) => {
            if (!acc[item.category_name]) {
              acc[item.category_name] = [];
            }
            acc[item.category_name].push(item);
            return acc;
          }, {});
          setAnnouncementList(groupedData);
        } else if (res.data.status === false) {
          console.log("Failed to fetch announcements:", res.data.message);
        }
      })
      .catch((error) => {
        console.error("Error fetching announcements:", error);
      });
  }, []);

  const handleAnnouncementClick = (event, url, item) => {
    event.preventDefault(); // Prevents default navigation

    // Example check: Assume `user.registeredAnnouncements` contains URLs of registered announcements
    const registeredAnnouncements = sessionStorage.getItem(
      "registeredAnnouncements"
    );

    if (registeredAnnouncements && registeredAnnouncements.includes(url)) {
      // User is registered, load data
      loadAnnouncementData(item);
    } else {
      // Open the URL normally
      window.open(url, "_blank");
    }
  };

  const loadAnnouncementData = (item) => {
    // Implement your API call to fetch the specific announcement's data
    AxiosInstance.get("api/all/getAnnouncement", { id: item.id })
      .then((res) => {
        if (res.status === 200) {
          // Handle the data as needed (update state, show modal, etc.)
        }
      })
      .catch((error) => {
        console.error("Error loading announcement details:", error);
      });
  };
  const [selectedValue, setSelectedValue] = useState("");
  const [selectedValueName, setSelectedValueName] = useState("");
  const [medium, setMedium] = useState("");
  const [mediumName, setMediumName] = useState("");
  const [course, setCourse] = useState("");
  const [courseName, setCourseName] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const [bookList, setBookList] = useState();
  const itemsPerPage = 8; // Items per page
  const [fullData, setFullData] = useState([]); // Initialize as empty array
  const [currentPage, setCurrentPage] = useState(0);
  const currentData =
    fullData.length > 0
      ? fullData.slice(
          currentPage * itemsPerPage,
          (currentPage + 1) * itemsPerPage
        )
      : [];

  useEffect(() => {
    loadListdata();
  }, []);

  const loadListdata = async () => {
    setIsLoading(true);
    try {
      const res = await AxiosInstance.post("/api/book/view_all_books", {
        user_id: userid,
        search: "",
        view_all_book: 1,
        popularity: 3, // default for best sellers
        category_id: "",
        group_course_id: "",
        subject_id: "",
        medium: "",
        is_set: "",
        tag_id: "",
        book_id: "",
        is_combo_offer: "",
        is_ebook: "",
        book_type: "",
      });
      if (res.data.status) {
        setFullData(res.data.data.slice(-24));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      toast.error("An error occurred while fetching data.");
    } finally {
      setIsLoading(false);
    }
  };
  const { cartNotify } = useContext(CartContext);
  const { WishNotify } = useContext(WishListContext);
  const toggleWishlist = (bookId, currentStatus) => {
    const payload = {
      user_id: userid,
      book_id: bookId,
      is_favorite: currentStatus == 1 ? 0 : 1, // Toggle is_favorite value
      created_by: userid,
      created_dt: moment().format("YYYY-MM-DD"),
    };

    AxiosInstance.post("/api/book/wishlist/add", payload)
      .then((res) => {
        if (res.data.status) {
          toast.success(res.data.message);
          loadListdata();
          WishNotify(userid);
        } else {
          toast.error(res.data.message);
          sessionStorage.clear();
          navigate("/login");
        }
      })
      .catch((error) => {
        console.error("Error updating wishlist:", error);
      });
  };
  const handleAddCart = async (bookIds) => {
    try {
      const res = await AxiosInstance.post("/api/book/cart/add", {
        id: "",
        user_id: userid,
        book_id: bookIds,
        created_dt: moment().format("YYYY-MM-DD"),
        created_by: userid,
      });
      if (res.data.status) {
        toast.success(res.data.message);
        loadListdata();
        cartNotify(userid);
      } else {
        toast.error(res.data.message);
        sessionStorage.clear();
        navigate("/login");
      }
    } catch (error) {
      console.error("Error adding to cart:", error);
    }
  };
  // Search state
  const [searchText, setSearchText] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedCategoryName, setSelectedCategoryName] = useState("");
  const [sseriesName, setSeriesName] = useState("");
  const [sseriesvalue, setSseriesvalue] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedMedium, setSelectedMedium] = useState("");
  // Category Array
  const [categories, setCategories] = useState([]);
  const [courses, setCourses] = useState([]);
  // Medium Array
  const [mediums, setMediums] = useState([
    { id: "1", name: "English" },
    { id: "0", name: "Tamil" },
    { id: "2", name: "Both" },
  ]);
  // Category API
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await AxiosInstance.get("api/course/category_list");
        if (response.data.status) {
          setCategories(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, []);

  useEffect(() => {
    fetchCourseList();
  }, [selectedCategory]);

  const fetchCourseList = async () => {
    if(selectedCategoryName){
    try {
      const response = await AxiosInstance.get(
        `api/all/getCourses/${selectedCategoryName}/0`
      );
      if (response.data.status) {
        setCourses(response.data.data);
      } else {
        console.error("API returned an error:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching course list:", error);
    }
  }
  };

  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
    setSelectedCategoryName(event.target.selectedOptions[0].text);
  };

  const handleChange = (e, namess) => {
    if (namess == "course_name") {
      setCourseName(e.target.selectedOptions[0].text);
      setCourse(e.target.value);
    } else if (namess == "medium_name") {
      setMediumName(e.target.selectedOptions[0].text);
      setMedium(e.target.value);
    } else {
      setSelectedValueName(e.target.selectedOptions[0].text);
      setSelectedValue(e.target.value);
    }
  };

  const seriesData = [
    {
      id: 0,
      seriesName: "A",
      seriesTitle: "A - Series Books",
      title: `Author Book Series - All Topics, One Book!`,
      description: `The comprehensive designed by expert faculties of our Academy to cover the entire 
syllabus.`,
    },
    {
      id: 1,
      seriesName: "B",
      seriesTitle: "B - Series Books",
      title: `Text Book Series -`,
      description: `A comprehensive book covering all essential 
topics of the syllabus from 6th to 12th Standard for respective 
subjects, making perfect companion for revision, learning and 
success.`,
    },
    {
      id: 2,
      seriesName: "GB",
      seriesTitle: "General Books",
      title: `Reference Book Series -`,
      description: `It is a collection of standard reference 
books for each subject by famous authors, providing invaluable 
companion for achieving success.`,
    },
    {
      id: 3,
      seriesName: "QB",
      seriesTitle: "AIASA Question Bank",
      title: `Question Bank Series -`,
      description: `This bank contains collection of thousands 
of topic wise questions for each subject curated by expert faculties of 
our Academy, covering complete syllabus for testing yourself as a 
track to success.`,
    },
    {
      id: 4,
      seriesName: "PYQ",
      seriesTitle: "TNPSC Previous Year Question Papers",
      title: `PYQ Bank Series -`,
      description: `A collection of thousands of questions from 
previous years’ question papers, compiled as subject wise books,
giving you a clear view of topic wise analysis.`,
    },
  ];
  const handleViewAllbooksnav = () => {
    navigate("/studyMaterials/Books/ViewAllBook", {
      state: {
        categoryId: selectedCategory,
        category_name: selectedCategoryName,
        course_name: courseName,
        medium_name: mediumName,
        courseId: course,
        mediumId: medium,
        search: searchText,
        series_value: "",
        series_name: "",
      },
    });
  };
  const handleGetSeries = (id, namess) => {
    setSearchText("");
    setSelectedCategory("");
    setCourse("");
    setMedium("");
    navigate("/studyMaterials/Books/ViewAllBook", {
      state: {
        series_value: id,
        series_name: namess,
      },
    });
  };
  const [selectedTags, setSelectedTags] = useState([]);
  const handleTagsFilter = (id, tagName) => {
    const newTag = [{ id, name: tagName, type: "selectedTags" }];
    setSelectedTags(newTag);
    navigate("/studyMaterials/Books/ViewAllBook", {
      state: {
        categoryId: selectedCategory,
        category_name: selectedCategoryName,
        course_name: courseName,
        medium_name: mediumName,
        courseId: course,
        mediumId: medium,
        search: searchText,
        series_value: "",
        SELECTEDTAGS: newTag,
      },
    });
  };

  return (
    <div className="AdmissionForm IndexPage FooterLink">
      <LogoutListener />
      {/* Notice Board */}
      <div className="row">
        <div className="col-md-12  p-0">
          {user?.user_id ? (
            <section className={`${styles.headerwel} StepOne`}>
              <h2 className="text-center">Welcome To Dashboard</h2>
              <div>
                {isExpanded ? (
                  // Expanded view with marquee content
                  <div className={styles.announcemt_container_user}>
                    <div
                      className={`${styles.Header_portion} d-flex justify-content-between p-lg-2 p-1`}
                    >
                      <span>Notice Board</span>
                      <span onClick={toggleView} style={{ cursor: "pointer" }}>
                        <ChevronRightIcon />
                      </span>
                    </div>
                    <div className={`${styles.marquee_portion}`}>
                      <marquee
                        className="p-2"
                        ref={marqueeRef}
                        width="100%"
                        direction="up"
                        height="240px"
                        behavior="scroll"
                        scrollamount="4"
                        onMouseEnter={() => marqueeRef.current?.stop()} // Stop scrolling on hover
                        onMouseLeave={() => marqueeRef.current?.start()} // Resume scrolling on leave
                      >
                        <div>
                          {Object.entries(announcementList).map(
                            ([categoryName, items], index) => (
                              <div key={index} style={{ marginBottom: "40px" }}>
                                <p className={styles.categoryName}>
                                  {categoryName}
                                </p>
                                <ul className={styles.decription}>
                                  {items.map((item, idx) => (
                                    <li key={idx} className={styles.decription}>
                                      <div className="row">
                                        <div className="col-1 align-content-center">
                                          <img
                                            className={styles.listImg}
                                            src={listImage}
                                            alt="Icon"
                                          />
                                        </div>
                                        <div className="col-9">
                                          <a
                                            href={item.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            onClick={(e) =>
                                              handleAnnouncementClick(
                                                e,
                                                item.url,
                                                item
                                              )
                                            }
                                            style={{
                                              textDecoration: "underline",
                                              color: "#2378e9",
                                              wordWrap: "break-word",
                                            }}
                                          >
                                            {item.description}
                                          </a>
                                        </div>
                                      </div>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            )
                          )}
                        </div>
                      </marquee>
                    </div>
                  </div>
                ) : (
                  // Collapsed view with left icon
                  <div className={styles.marquee_left_icon_user}>
                    <span onClick={toggleView} style={{ cursor: "pointer" }}>
                      <ChevronLeftIcon />
                    </span>
                  </div>
                )}
              </div>

              {user_type === 2 &&
                showModalData.res_ids &&
                showModalData.res_ids.length > 0 &&
                showModalData.res_ids.map((el, index) => (
                  <PaymentDueModel
                    showModalData={el}
                    show={el.status !== false ? true : false}
                    admission_type={el.admission_type}
                    adm_pk={el.adm_pk}
                    user_id={userid}
                    section={el.section}
                    index={index}
                    key={index} // Don't forget to add a unique key for each item in the array
                  />
                ))}
              {user_type === 2 &&
                showModalData.res_idss &&
                showModalData.res_idss.length > 0 &&
                showModalData.res_idss.map((el, index) => {
                  <PaymentDueModel
                    showModalData={el}
                    show={el.status !== false ? true : false}
                    adm_pk={el.adm_pk}
                    admission_type={el.admission_type}
                    section={el.section}
                    user_id={userid}
                    index={index}
                  />;
                })}
            </section>
          ) : (
            <div
              id="carouselExampleIndicators"
              className="carousel slide "
              data-ride="carousel"
            >
              <ol className={`${styles.carousel_indicators}`}>
                {images.map((_, index) => (
                  <li
                    key={index}
                    title={activeIndex}
                    data-target="#carouselExampleIndicators"
                    data-slide-to={index}
                    className={index === activeIndex ? "active" : ""}
                  ></li>
                ))}
              </ol>
              <div
                className="carousel-container"
                style={{
                  position: "relative",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div className="carousel-inner" style={{ flex: 1 }}>
                  {images.map((sd, index) => (
                    <div
                      key={index}
                      titleone={activeIndex}
                      className={`carousel-item ${
                        index === activeIndex ? "active" : ""
                      }`}
                    >
                      <img
                        style={{ maxHeight: "450px" }}
                        className="d-block w-100"
                        src={`${ImageUrlPrefix}/${sd.banner_path}`}
                        alt={`Slide ${index + 1}`}
                      />
                    </div>
                  ))}
                </div>
              </div>
              <div>
                {isExpanded ? (
                  // Expanded view with marquee content
                  <div className={styles.announcemt_container}>
                    <div
                      className={`${styles.Header_portion} d-flex justify-content-between p-lg-2 p-1`}
                    >
                      <span>Notice Board</span>
                      <span onClick={toggleView} style={{ cursor: "pointer" }}>
                        <ChevronRightIcon />
                      </span>
                    </div>
                    <div className={`${styles.marquee_portion}`}>
                      <marquee
                        className="p-2"
                        ref={marqueeRef}
                        width="100%"
                        direction="up"
                        height="240px"
                        behavior="scroll"
                        scrollamount="4"
                        onMouseEnter={() => marqueeRef.current?.stop()} // Stop scrolling on hover
                        onMouseLeave={() => marqueeRef.current?.start()} // Resume scrolling on leave
                      >
                        <div>
                          {Object.entries(announcementList).map(
                            ([categoryName, items], index) => (
                              <div key={index} style={{ marginBottom: "40px" }}>
                                <p className={styles.categoryName}>
                                  {categoryName}
                                </p>
                                <ul className={styles.decription}>
                                  {items.map((item, idx) => (
                                    <li key={idx} className={styles.decription}>
                                      <div className="row">
                                        <div className="col-1 align-content-center">
                                          <img
                                            className={styles.listImg}
                                            src={listImage}
                                            alt="Icon"
                                          />
                                        </div>
                                        <div className="col-9">
                                          <a
                                            href={item.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            onClick={(e) =>
                                              handleAnnouncementClick(
                                                e,
                                                item.url,
                                                item
                                              )
                                            }
                                            style={{
                                              textDecoration: "underline",
                                              color: "#2378e9",
                                              wordWrap: "break-word",
                                            }}
                                          >
                                            {item.description}
                                          </a>
                                        </div>
                                      </div>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            )
                          )}
                        </div>
                      </marquee>
                    </div>
                  </div>
                ) : (
                  // Collapsed view with left icon
                  <div className={styles.marquee_left_icon}>
                    <span onClick={toggleView} style={{ cursor: "pointer" }}>
                      <ChevronLeftIcon />
                    </span>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
      {/* Course Category Portion */}
      <CourseCategory />
      {/* {console.log(user_type, "user_type")} */}
      {/* {(user_type == 2 || !user_type) && <BestSellers />} */}
      {/* Study Material serach and Book series */}
      {(user_type == 2 || !user_type) && (
        <div className="studyMaterial my-5">
          <div className="m-lg-4 m-3">
            <h3
              className={`${styless.courseTitle} text-center position-relative`}
            >
              Your Success Starts with the R
              <span>
                <img
                  className={`${styless.course_underline_img}`}
                  src={red_undeline}
                  alt="word_underline"
                />
              </span>
              ight Book
            </h3>
            <p className={`${styless.subtitle}`}>
              Filter by category, course and medium to find exactly what you
              need.
            </p>

            <div
              className={`${style.searchBooks} d-flex flex-wrap  justify-content-evenly py-4 p-lg-2 my-4`}
            >
              {/* ----Search---- */}
              <div
                className={`${style.borderedEnter_vr} ${style.searchInput} d-flex align-items-center`}
              >
                <span
                  onClick={handleViewAllbooksnav}
                  className="material-icons"
                >
                  search
                </span>
                <input
                  placeholder="Enter Book Names/Subjects"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleViewAllbooksnav();
                    }
                  }}
                  className={`${style.no_focus} w-100`}
                />
              </div>
              {/* ----Select Category---- */}
              <div className={`${style.bordered_vr}`}>
                <select
                  className={`${styless.custom_width} ${styless.dropdownarrow_img} ${styless.select} ${style.select} form-select w-100 cursorPnt`}
                  onChange={handleCategoryChange}
                  value={selectedCategory}
                >
                  <option value="" hidden className="cursorPnt">
                    {categories.length > 0
                      ? "Select Category"
                      : "No category available"}
                  </option>
                  {categories.map((category) => (
                    <option
                      className="cursorPnt"
                      key={category.id}
                      value={category.id}
                      name={category.name}
                    >
                      {category.name}
                    </option>
                  ))}
                </select>
              </div>
              {/* ----Select Course---- */}
              <div className={`${style.bordered_vr} col-md-2`}>
                <select
                  className={`${styless.custom_width} ${styless.dropdownarrow_img} ${styless.select} ${style.select} form-select w-100`}
                  onChange={(e) => handleChange(e, "course_name")}
                  value={course}
                >
                  <option value="" hidden>
                    {courses.length > 0 ? "Select Course" : "Select Course"}
                  </option>
                  {courses.map((course) => (
                    <option
                      key={course.id}
                      value={course.id}
                      name={course.course_name}
                    >
                      {course.course_name}
                    </option>
                  ))}
                </select>
              </div>
              {/* ----Select Medium---- */}
              <div className={style.bordered_vr}>
                <select
                  className={`${styless.custom_width} ${styless.dropdownarrow_img} ${styless.select} ${style.select} form-select w-100`}
                  value={medium}
                  onChange={(e) => handleChange(e, "medium_name")}
                >
                  <option value="" hidden>
                    Select Medium
                  </option>
                  {mediums.map((medium) => (
                    <option
                      key={medium.id}
                      value={medium.id}
                      name={medium.name}
                    >
                      {medium.name}
                    </option>
                  ))}
                </select>
              </div>
              {/* ---Submit Button ----*/}
              <div className="row mx-0 p-0">
                <div className="px-0 col-xl-12 col-lg-12 col-md-12 col-12 ">
                  <Link
                    to="javascript:void(0)"
                    onClick={handleViewAllbooksnav}
                    className={`primaryButton text-center ${style.fullWidthSearchBtn}  `}
                    variant="primary"
                  >
                    Search Books
                  </Link>
                </div>
              </div>
            </div>
          </div>
          {/* separator image */}
          <div className={`${styles.separator_pattern_left} my-lg-5 my-3`}>
            <img
              src={separator_pattern_left}
              alt="separator_pattern_left"
              className={`${styles.separator_pattern_left}`}
              style={{ width: "50%", height: "auto", objectFit: "cover" }}
            />
          </div>
          {/* Group books */}
          <div className="m-lg-0 m-3">
            <h3
              className={`${styless.courseTitle} text-center position-relative`}
            >
              Books Organized for E
              <span>
                <img
                  className={`${styless.course_underline_img}`}
                  src={red_undeline}
                  alt="word_underline"
                />
              </span>
              asy Selection
            </h3>
            <p className={`${styless.subtitle}`}>
              Navigate through well-defined categories to find and purchase the
              right books for your exam success!
            </p>
            {/* series card portion */}
            <div
              className={`${style.seriesCard} row d-flex justify-content-evenly px-2 p-lg-0`}
            >
              {seriesData.map((series, index) => (
                <div
                  key={index}
                  className={`${style.seriesPortion} col-lg-2 col-12 p-0 mb-lg-0 mb-4 d-flex flex-column`}
                >
                  <div className="d-flex justify-content-end">
                    <span className={style.seriesName}>
                      {series.seriesName}
                    </span>
                  </div>

                  <div className={`${style.contentPortion} p-2 flex-grow-1`}>
                    <p className={style.seriesTitle}>{series.seriesTitle}</p>
                    <span className={`${style.descriptionValue} m-0 p-0`}>
                      <span style={{ fontWeight: 600 }}>{series.title}</span>{" "}
                      {series.description}
                    </span>
                  </div>

                  <div className="mt-auto px-0">
                    <Link
                      to="javascript:void(0)"
                      onClick={() =>
                        handleGetSeries(series.id, series.seriesName)
                      }
                      className={`primaryButton text-center ${style.fullWidthButton}`}
                      variant="primary"
                    >
                      View All Books
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
          {/* separator left image */}
          <div
            className={`${styless.separator_pattern_right} d-flex justify-content-end my-lg-5`}
          >
            <img
              src={separator_pattern_right}
              alt="separator_pattern_right"
              className={`${style.separator_pattern_right}`}
            />
          </div>
        </div>
      )}
      {/* Top10squad portion */}
      <Top10squad />
    </div>
  );
}
export default IndexPage;
